import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {AbstractApiProvider} from "data/providers/api/abstract.api.provider";

export interface IPredictionImage {
	imagePath: string;
}

export interface IPredictionImageParams {
	roundId: number;
	locale: string;
}

type TCrunchResponse = IApiResponse<IPredictionImage>;

export interface ISharingApiProvider {
	getPredictionImage: (data: IPredictionImageParams) => Promise<AxiosResponse<TCrunchResponse>>;
}

@injectable()
export class SharingApiProvider extends AbstractApiProvider implements ISharingApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {
		super();
	}

	getPredictionImage = (data: IPredictionImageParams) =>
		this._http.get<TCrunchResponse>(`${this.language}/share/prediction/image`, data);
}
